import { useEffect, useState } from "react";
import Switch from "react-switch";

interface AlertSwitchProps {
  active: boolean;
  id: string | number;
  onSwitchChange?: (checked: boolean, id: string | number) => void;
  disabled?: boolean;
}

const AlertSwitch = ({ active, id, onSwitchChange, disabled }: AlertSwitchProps) => {
  const [checked, setChecked] = useState(active);

  const handleChange = (checked: boolean) => {
    setChecked(checked);
    if (onSwitchChange) {
      onSwitchChange(checked, id);
    }
  };

  useEffect(() => {
    setChecked(active);
  }, [active]);

  return (
    <label>
      <Switch onChange={handleChange} checked={checked} disabled={disabled} />
    </label>
  );
};

export default AlertSwitch;
